function SpinnerView(props) {
    return (
        <>
            <div className="border-gray-300 h-6 w-6 animate-spin rounded-full border-4 border-t-yellow-500" />
        </>
    );
}

export default SpinnerView;
